/* eslint-disable import/prefer-default-export */
export { default as CourseCarousel } from './CourseCard/CourseCarousel';
